<div
  [ngClass]="{ 'bg-[var(--sabbia-300)]': item.isActive }"
  class="flex items-center gap-2 rounded-[0.375rem] hover:bg-[var(--sabbia-300)] p-2 w-full cursor-pointer"
  (click)="onItemClick()"
>
  <ng-icon hlm size="sm" [name]="item.lucideIconName" />
  <span class="font-normal text-sm text-[#3F3F46]">{{ item.label }}</span>
</div>
